export default "__VITE_ASSET__BywdHBtt__"